import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider, SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import './index.css';
import App from './App';

// Clerk is optional at build time. With a publishable key the ENTIRE console is
// gated behind sign-in (a real front door); without one it falls back to the
// legacy operator login (dev/local).
const clerkKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const BRAND_LOGO = process.env.REACT_APP_BRAND_LOGO
  || 'https://auditedmedia.com/hs-fs/hubfs/Logos/AAM-Logo-Primary-2C-Pos-RGB.png?width=500&name=AAM-Logo-Primary-2C-Pos-RGB.png';

// Centered sign-in card shown to signed-out visitors.
function SignInGate() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 24,
      background: 'radial-gradient(1200px 600px at 50% -10%, #12202a 0%, #0b0f14 60%)',
    }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '14px 22px' }}>
        <img src={BRAND_LOGO} alt="Alliance for Audited Media" style={{ height: 40, display: 'block' }} />
      </div>
      <div style={{ color: '#e6edf3', fontFamily: 'Inter, system-ui, sans-serif', textAlign: 'center' }}>
        <div style={{ fontSize: 15, opacity: 0.75 }}>Sign in to issue and manage verifiable credentials</div>
      </div>
      <SignIn routing="hash" appearance={{ layout: { logoImageUrl: BRAND_LOGO } }} />
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {clerkKey ? (
      <ClerkProvider publishableKey={clerkKey}>
        <SignedIn><App /></SignedIn>
        <SignedOut><SignInGate /></SignedOut>
      </ClerkProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);